export const PURCHASE_ORDER_PAGE_TITLE = "Đơn mua hàng / Nhập kho";

export const FORM_IDS = {
  CREATE: "create-purchase-order-form",
};
